import './App.css';
import './bootstrap/css/bootstrap.min.css';
import './fontawesome/css/fontawesome.css';
import './fontawesome/css/brands.css';
import './fontawesome/css/solid.css';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

import {TEKSTOJ} from './tekstoj.js';
import NodŜarĝilo from './NodŜarĝilo.js';
import Nodo from './Nodo.js';
import Vorto from './Vorto.js';
import Vortaro from './Vortaro.js';
import Strukturo from './Strukturo.js';
import {Enkonduko, Instrukcioj, Meritoj, Kunlaboro} from './Informpaĝoj.js';

//import Lingvoj from './Lingvoj.js';
import Lingvo from './Lingvo.js';
import {LINGVOJ} from './Lingvoj.js';

import Table from 'react-bootstrap/Table';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from 'react';
import { useContext } from 'react';

import {FasadaLingvoKunteksto, VortaroLingvojKunteksto, ReĝimoKunteksto, UzantoKunteksto} from './Kunteksto.js';
import {BAZA_URL} from './Kunteksto.js';
// var LINGVOJ = new Lingvoj();

function Eraro() {
  return (
    <Alert dismissible variant="danger">
      <Alert.Heading>Okazis iu problemo</Alert.Heading>
      <p>Fakte ne, tio estas nur testo.</p>
    </Alert>
  );
}

function NavigiloPri ()
{
    const {reĝimo, agorduReĝimon} = useContext (ReĝimoKunteksto);
   
    function ŝanĝuReĝimon (novareĝimo)
    {
       agorduReĝimon (novareĝimo) 
    }
    
    return (<DropdownButton id="dropdown-basic-button" title="Pri la vortaro">
      <Dropdown.Item href="#enkonduko" onClick={() => {ŝanĝuReĝimon('enkonduko')}}>Enkonduko</Dropdown.Item>
      <Dropdown.Item href="#instrukcioj" onClick={() => {ŝanĝuReĝimon('instrukcioj')}}>Kiel uzi ĝin</Dropdown.Item>
      <Dropdown.Item href="#meritoj" onClick={() => {ŝanĝuReĝimon('meritoj')}}>Nia teamo</Dropdown.Item>
      <Dropdown.Item href="#kulaboro" onClick={() => {ŝanĝuReĝimon('kunlaboro')}}>Kunlaboro</Dropdown.Item>
    </DropdownButton>);     
}

function Navigilo({agorduModEnsaluti}){
    const {reĝimo, agorduReĝimon} = useContext (ReĝimoKunteksto);
    const {uzanto, agorduUzanton} = useContext (UzantoKunteksto);
    
    function ŝanĝuReĝimon (novareĝimo)
    {
       agorduReĝimon (novareĝimo) 
    }
    
    if (uzanto != null)
    {
    //<Nav.Link href="#strukturo" onClick={() => {ŝanĝuReĝimon('strukturo')}}>Redakti</Nav.Link>  
    //<Nav.Link href="#strukturo" onClick={() => {alert ('Ne funkcias en publika retpaĝaro.')}}>Redakti</Nav.Link>                
     return (<Navbar bg="primary" data-bs-theme="dark">
        <Container>
          <Navbar.Brand href="#vortaro" onClick={() => {ŝanĝuReĝimon('libro')}}>{TEKSTOJ.teksto('NAVIGILO_VORTARO')}</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="#sercxi" onClick={() => {ŝanĝuReĝimon('serĉilo')}}>{TEKSTOJ.teksto('NAVIGILO_SERĈI')}</Nav.Link>
            <Nav.Link href="#lingvoj" onClick={() => {ŝanĝuReĝimon('lingvoj')}}>{TEKSTOJ.teksto('NAVIGILO_LINGVOJ')}</Nav.Link>
            <Nav.Link href="#strukturo" onClick={() => {ŝanĝuReĝimon('strukturo')}}>Redakti</Nav.Link>            
            <Nav.Link href="#uzanto" onClick={() => {agorduModEnsaluti(true);}}>{TEKSTOJ.teksto('NAVIGILO_UZANTO')}</Nav.Link>
            <NavigiloPri />           
          </Nav>
        </Container>
      </Navbar>
      );
    }
    else // neniu uzanto
    {
     return (<Navbar bg="primary" data-bs-theme="dark">
        <Container>
          <Navbar.Brand href="#vortaro" onClick={() => {ŝanĝuReĝimon('libro')}}>{TEKSTOJ.teksto('NAVIGILO_VORTARO')}</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="#sercxi" onClick={() => {ŝanĝuReĝimon('serĉilo')}}>{TEKSTOJ.teksto('NAVIGILO_SERĈI')}</Nav.Link>
            <Nav.Link href="#lingvoj" onClick={() => {ŝanĝuReĝimon('lingvoj')}}>{TEKSTOJ.teksto('NAVIGILO_LINGVOJ')}</Nav.Link>          
            <Nav.Link href="#uzanto" onClick={() => {agorduModEnsaluti(true);}}>{TEKSTOJ.teksto('NAVIGILO_UZANTO')}</Nav.Link>
            <NavigiloPri />
          </Nav>
        </Container>
      </Navbar>
      );        
    }
}

function ensaluti (uzantNomo, pasvorto, agorduUzanton)
{
   // alert ("uzanto: " + uzantNomo + "\npasvorto: " + pasvorto);
    const  request = new XMLHttpRequest();
        const url = BAZA_URL + "ensaluti.php";
        request.open('POST', url);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        request.onload = function ()
        {
            console.log(request.responseText);
            const data = JSON.parse (request.responseText);
            prilaboruEnsaluton (data, agorduUzanton);
        };
        request.withCredentials = true;
        request.send('ENSALUTNOMO=' + encodeURIComponent (uzantNomo) + "&PASVORTO=" + encodeURIComponent (pasvorto));        
}

function prilaboruEnsaluton (data, agorduUzanton)
{
    if (data.ensalutita)
    {
        agorduUzanton (data.uzanto);
        alert ("Ensalutita\n" + data.uzanto.nomo);
    }
    else
    {
        agorduUzanton (null);
        alert ('Malpermesita.');
    }
}

function FormEnsaluti ( {modEnsaluti, agorduModEnsaluti, nodŝarĝilo} )
{
    const {uzanto, agorduUzanton} = useContext (UzantoKunteksto);
    
    function ensalutu()
    {
       let elSalutnomo = document.getElementById ('salutnomo');
       let elPasvorto = document.getElementById ('pasvorto');
       ensaluti (elSalutnomo.value, elPasvorto.value, agorduUzanton);
       agorduModEnsaluti (false);
    }

        
  const handleClose = () => agorduModEnsaluti (false);
  
  return (
      <Modal show={modEnsaluti} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Ensaluti</Modal.Title>
        </Modal.Header>
        <Modal.Body>
    <Form>
      <Form.Group className="mb-3" controlId="formGroupEmail">
        <Form.Label>Ensalutnomo</Form.Label>
        <Form.Control id="salutnomo" type="text" />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formGroupPassword">
        <Form.Label>Pasvorto</Form.Label>
        <Form.Control id="pasvorto" type="password" />
      </Form.Group>
    </Form>
    </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Fermu</Button>
          <Button variant="primary" onClick={ensalutu}>Ensalutu</Button>
        </Modal.Footer>
      </Modal>
  );      
}


function LingvoElektiloFasado ({id, valoro})
{
    var elementoj = [];
    for (let lingvo of LINGVOJ.fasadLingvoj)
    {
        let elId = 'lingvo-' + id + '-' + lingvo.id;
        elementoj.push (<option id={elId} value={lingvo.id}>{lingvo.nacinomo}</option>);
    }

    return (<Form.Select id={id} defaultValue={valoro}>
             {elementoj}
          </Form.Select>)
}

function LingvoElektiloVortaro ({id, ordo, listo})
{
        var valoro = ordo <= listo.length ? listo[ordo - 1] : 0;
        var elementoj = [];
        if (ordo > 1)
        {
           let elId = 'lingvo-' + id + '-nenio';
           elementoj.push (<option id={elId} value="nenio">{TEKSTOJ.teksto('LINGVO_NENIO')}</option>);
        }
        for (let lingvo of LINGVOJ.vortarLingvoj)
        {
            let elId = 'lingvo-' + id + '-' + lingvo.id;
            //console.log (elId);
            elementoj.push (<option id={elId} value={lingvo.id}>{lingvo.nacinomo}</option>);
        }

        return (<Form.Select id={id} defaultValue={valoro}>
             {elementoj}
          </Form.Select>)
}

function LingvojAgordilo({nodŝarĝilo})
{
  const {fasadlingvo, agorduFasadLingvon} = useContext (FasadaLingvoKunteksto);
  const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
  const {reĝimo, agorduReĝimon} = useContext (ReĝimoKunteksto);  
  
  function lingvonEnListon (listo, valoro)
  {
     if (valoro == 'nenio') 
     {
         return;
     }
     var lingvo = parseInt (valoro)
     if (!listo.includes (lingvo))
     {
         listo.push(lingvo);
     }
  }
  
  function agordu ()
  {
      const elFasadLingvo = document.getElementById ('fasadlingvo');
      const elVortarLingvo1  = document.getElementById ('vortarlingvo1');
      const elVortarLingvo2  = document.getElementById ('vortarlingvo2');
      const elVortarLingvo3  = document.getElementById ('vortarlingvo3');
      
      TEKSTOJ.ŝarĝuTekstojn(parseInt(elFasadLingvo.value), agorduFasadLingvon);
      var lingvoj = [];
      lingvonEnListon (lingvoj, elVortarLingvo1.value);
      lingvonEnListon (lingvoj, elVortarLingvo2.value);
      lingvonEnListon (lingvoj, elVortarLingvo3.value);
      agorduVortarLingvojn (lingvoj);
      nodŝarĝilo.agorduLingvojn (lingvoj); 
      nodŝarĝilo.reŝarĝu ();
      agorduReĝimon ('libro');
  }

return (<>
<h2>{TEKSTOJ.teksto('LINGVOJ_TITOLO')}</h2>
<div className="helpo">{TEKSTOJ.teksto('LINGVOJ_HELPO')}</div>
<Form>
    <Container>
        <Row>
            <Col>
            <Form.Group className="mb-3">
                <Form.Label htmlFor="fasadlingvo">{TEKSTOJ.teksto('FASADO_LINGVO')}</Form.Label>
                <LingvoElektiloFasado id="fasadlingvo" valoro={fasadlingvo} />
            </Form.Group>      
            </Col>
            <Col>
            <Form.Group className="mb-3">
                <Form.Label htmlFor="vortarlingvo1">{TEKSTOJ.teksto('VORTARO_LINGVO1')}</Form.Label>
                <LingvoElektiloVortaro id="vortarlingvo1" ordo="1" listo={vortarlingvoj} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label htmlFor="vortarlingvo2">{TEKSTOJ.teksto('VORTARO_LINGVO2')}</Form.Label>
                <LingvoElektiloVortaro id="vortarlingvo2" ordo="2" listo={vortarlingvoj} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label htmlFor="vortarlingvo3">{TEKSTOJ.teksto('VORTARO_LINGVO3')}</Form.Label>
                <LingvoElektiloVortaro id="vortarlingvo3" ordo="3" listo={vortarlingvoj} />
            </Form.Group>        
            </Col>
        </Row>
    </Container>
</Form>

<Button onClick = {agordu}>{TEKSTOJ.teksto('LINGVOJ_AGORDU')}</Button>
</>)    
    
}

function ŝarĝite (agorduReĝimon)
{
    if (LINGVOJ.ŝarĝita)
    {
//        agorduReĝimon ('libro');
        agorduReĝimon ('enirpaĝo');
    }
}

function LingvoElektiloSerĉilo ({id})
{
        const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);

        var valoro = vortarlingvoj[0];
        var elementoj = [];

        for (let lingvoid of vortarlingvoj)
        {
            let lingvo = LINGVOJ.lingvo (lingvoid);
            let elId = 'lingvo-' + id + '-' + lingvo.id;
            //console.log (elId);
            elementoj.push (<option id={elId} value={lingvo.id}>{lingvo.nacinomo}</option>);
        }

        return (<Form.Select id={id} defaultValue={valoro}>
             {elementoj}
          </Form.Select>)
}


function Serĉilo({nodŝarĝilo}){
   
    function serĉi()
    {
        const elVorto = document.getElementById ('vorto');
        const elLingvo = document.getElementById ('lingvo');
        const elEnTitoloj = document.getElementById ('entitoloj');
        const elEnKapvortoj = document.getElementById ('enkapvortoj');
        const elEnRilataj = document.getElementById ('enrilataj');
        
        if (elVorto != null)
        {
           nodŝarĝilo.ŝarĝuNodojnEnhavantajnVorton (elVorto.value, elLingvo.value, elEnTitoloj.checked, elEnKapvortoj.checked, elEnRilataj.checked);
        }
    }
    
    return (<Form>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="vorto">{TEKSTOJ.teksto('SERĈU_TITOLO')}</Form.Label>
          <Form.Control as="input" type="text" id="vorto" />
        </Form.Group>
        <Form.Group className="mb-30">
          <Form.Label htmlFor="lingvo">{TEKSTOJ.teksto('SERĈU_LINGVO')}</Form.Label>
          <LingvoElektiloSerĉilo id="lingvo" />
        </Form.Group>
               <div key={`inline`} className="mb-3">
               <Form.Label>Serĉu en:&nbsp;</Form.Label>
          <Form.Check
            inline
            label="titoloj"
            name="group1"
            type="checkbox"
            id="entitoloj"
            defaultChecked={true}
          />
          <Form.Check
            inline
            label="kapvortoj"
            name="group1"
            type="checkbox"
            id="enkapvortoj"
            defaultChecked={true}
          />
          <Form.Check
            inline
            label="rilataj vortoj"
            type="checkbox"
            id="enrilataj"
            defaultChecked={true}
          />
        </div>
    <Button onClick = {serĉi}>{TEKSTOJ.teksto('SERĈU')}</Button>
    </Form>)
}

function Enirpaĝo()
{
      return (<>
       <div className="enirpaĝo">
       <h1>CELTRAFO</h1>
       <img src="celtrafo.png" alt="Celtrafo" />
       <h1>{TEKSTOJ.teksto ('MLTV')}</h1>
       <p>&copy; 2003&ndash;2025 Ilona Koutny</p>
       <p>Kunlaborantoj: Miroslav Malovec (ĉeĥa versio); Yu Jinchao, Zhang Chenhsheng, Long Yunxia, Sun Yesheng (ĉina versio); Maciej Jaskot (pola versio);<br />
       Cyril Brosch, Horst Vogt (germana versio); Michael Farris, Bradio V. Moro III (anglalingva kontrolo); Gong Xiaofeng, Li Weilun (ĉinlingva kontrolo)</p>
       <p>Programisto: Milan Kolka</p>
       <p>Ĉiuj rajtoj rezervitaj.</p>
       </div>
    </>)    
}

function ĈefParto()
{   
    const [nodoj, agorduNodojn] = useState(null);
    const {reĝimo, agorduReĝimon} = useContext (ReĝimoKunteksto); 
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    
    const [nodŝarĝilo, agorduNodŜarĝilon] = useState (new  NodŜarĝilo (agorduNodojn, vortarlingvoj));
    nodŝarĝilo.agorduLingvojn (vortarlingvoj);
    switch (reĝimo)
    {
        case 'enirpaĝo':
            return (<Enirpaĝo />);
            break;
        case 'libro': return (<>
            <Vortaro nodoj={nodoj} nodŝarĝilo={nodŝarĝilo}/>
            </>);
        break;
    
        case 'serĉilo': return (<>
            <Serĉilo nodŝarĝilo={nodŝarĝilo} />
            <Vortaro nodoj={nodoj} nodŝarĝilo={nodŝarĝilo}/>
            </>);
        break;
        case 'lingvoj': return (<>
            <LingvojAgordilo nodŝarĝilo={nodŝarĝilo}/>
            </>);
        case  'strukturo':
            return (<Strukturo nodoj={nodoj} nodŝarĝilo={nodŝarĝilo}/>);
        case 'enkonduko':
            return (<Enkonduko />);
        case 'instrukcioj':
            return (<Instrukcioj />);
        case 'meritoj':
            return (<Meritoj />);
        case 'kunlaboro':
            return (<Kunlaboro />);
    }
}

function App() {
    const [fasadlingvo, agorduFasadLingvon] = useState(null);
    const [vortarlingvoj, agorduVortarLingvojn] = useState([41, 42]);
    const [reĝimo, agorduReĝimon] = useState ("init");
    const [uzanto, agorduUzanton] = useState (null);
    const [modEnsaluti, agorduModEnsaluti] = useState (false);
    
    if (!LINGVOJ.ŝarĝita)
    {
        LINGVOJ.ŝarĝuLingvojn (function (){ŝarĝite (agorduReĝimon);});
    }
    
    if (!TEKSTOJ.ŝarĝita)
    {
        TEKSTOJ.ŝarĝuTekstojn (42, agorduFasadLingvon);
    }
    
    //console.log ("Lingvo: "  + navigator.language);
    //console.log ("Lingvoj: " + navigator.languages);
    
  return (
    <div className="App">
     <UzantoKunteksto.Provider value={{uzanto, agorduUzanton}}>
     <FasadaLingvoKunteksto.Provider value={{fasadlingvo, agorduFasadLingvon}}>
       <VortaroLingvojKunteksto.Provider value={{vortarlingvoj, agorduVortarLingvojn}}>
           <ReĝimoKunteksto.Provider value={{reĝimo, agorduReĝimon}}>
               
      <header className="App-header">
          <h1>{TEKSTOJ.teksto ('MLTV')} <i className="fa-solid fa-user"></i></h1>
          <Navigilo agorduModEnsaluti={agorduModEnsaluti} />
          <FormEnsaluti modEnsaluti={modEnsaluti} agorduModEnsaluti={agorduModEnsaluti} />
      </header>
      <hr />
      <ĈefParto />
      </ReĝimoKunteksto.Provider>
      </VortaroLingvojKunteksto.Provider>
      </FasadaLingvoKunteksto.Provider>
      </UzantoKunteksto.Provider>
    </div>
  );
}

export default App;
